<template>
  <el-submenu :class="supClass" :index="data.route">
    <template slot="title">
      <span class="active-color" />
      <i :class="data.iconClass" />
      <span>{{ data.name }}</span>
    </template>
    <el-menu-item v-for="child in data.children" :key="child.route" :index="child.route">
      <!-- <i :class="child,$route.meta | transIcon" /> -->
      <span slot="title" :class="{ active: child.route === activeIndex }">{{ child.name }}</span>
    </el-menu-item>
  </el-submenu>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "SubMenu",
  filters: {
    transIcon({ route, iconClass }, routeMeta) {
      // return routeMeta[0].url + routeMeta[1].url === route ? `${iconClass}-active` : iconClass
    },
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      activeIndex: "",
    };
  },
  computed: {
    ...mapState(["tipNum"]),
    supClass() {
      const { $route, activeIndex } = this;
      const routeObj = this.data;
      const menuRoute = routeObj.route;
      if (routeObj.children) {
        const childRoutes = routeObj.children.map((item) => item.route);
        const childActive = childRoutes.some((item) => {
          return $route.path.includes(item) || item === activeIndex;
        });
        return childActive ? "sup-active" : "";
      }
      return $route.path === menuRoute ? "sup-active" : "";
    },
  },
  watch: {
    $route(val) {
      this.activeIndex = val.meta[val.meta.length - 1].activeRoute;

      this.SET_ROUTER_ACTIVE(this.activeIndex);
    },
  },
  mounted() {
    this.activeIndex = this.$route.meta[this.$route.meta.length - 1].activeRoute;
    this.SET_ROUTER_ACTIVE(this.activeIndex);
  },
  methods: {
    ...mapMutations(["SET_ROUTER_ACTIVE"]),
  },
};
</script>

<style scoped>
.active {
  color: #1890ff;
}
.sup-active .active-color {
  display: inline-block;
  position: relative;
  left: -10px;
  width: 3px;
  height: 22px;
  background: #1890ff;
}
</style>
